import { SinglePaymentMethod } from '@nemuru-eng/js-api-client';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { SelectOption } from '@/types/selectOption';

export const SinglePaymentMethodOptions = (t: GetTextIdTranslationType): SelectOption[] =>
  Object.keys(SinglePaymentMethod).map((singlePayment) => ({
    value: singlePayment.toLowerCase(),
    display: t(singlePayment.toLowerCase()) || singlePayment.toLowerCase(),
  }));
